import { useTranslation } from 'react-i18next'
import { useWindowActions } from '../../../../models/window'
import { copyToClipboard } from '../../../../core/helpers/copy-to-clipboard'
import SheetModal from '../sheet-modal/sheet-modal'
import c from './case-reward-modal.module.scss'

const CaseRewardModal = ({ promoCode, caseName, caseImage }) => {
    const { t } = useTranslation()
    const { closeWindow } = useWindowActions()

    const handleCopy = () => {
        if (promoCode) {
            copyToClipboard(promoCode)
        }
    }

    const handleClaim = () => {
        const url = 'https://ggstand.live'
        try {
            if (window?.Telegram?.WebApp?.openLink) {
                window.Telegram.WebApp.openLink(url)
            } else {
                window.open(url, '_blank')
            }
        } catch (e) {
            window.open(url, '_blank')
        }
        closeWindow()
    }

    return (
        <SheetModal>
            <div className={c.component}>
                {caseImage && <img className={c.image} src={caseImage} alt="" />}
                {caseName && <h3 className={c.title}>{caseName}</h3>}
                {promoCode && (
                    <div className={c.codeBlock}>
                        <span className={c.code}>{promoCode}</span>
                        <span className={c.codeLabel}>{t('earnings.caseReward.promoCode')}</span>
                    </div>
                )}
                <div className={c.buttons}>
                    <button className={c.copyBtn} onClick={handleCopy}>
                        {t('earnings.caseReward.copy')}
                    </button>
                    <button className={c.claimBtn} onClick={handleClaim}>
                        {t('earnings.caseReward.get')}
                    </button>
                </div>
            </div>
        </SheetModal>
    )
}

export default CaseRewardModal
